export interface JourneyStep {
  id: string;
  titleKey: string;
  descriptionKey: string;
  icon: string;
  color: string;
  position: { x: number; y: number; z: number };
  rotation: { x: number; y: number; z: number };
  skills: string[];
}

export const journeySteps: JourneyStep[] = [
  {
    id: 'field',
    titleKey: 'journey.field',
    descriptionKey: 'journey.field.desc',
    icon: '🌱',
    color: '#00ff88',
    position: { x: -15, y: 0, z: 5 },
    rotation: { x: 0, y: 0.5, z: 0 },
    skills: ['agri', 'prompt'],
  },
  {
    id: 'drone',
    titleKey: 'journey.drone',
    descriptionKey: 'journey.drone.desc',
    icon: '🚁',
    color: '#00d4ff',
    position: { x: -8, y: 8, z: 10 },
    rotation: { x: -0.3, y: 0.8, z: 0 },
    skills: ['drone', 'sales'],
  },
  {
    id: 'sales',
    titleKey: 'journey.sales',
    descriptionKey: 'journey.sales.desc',
    icon: '🤝',
    color: '#ffd700',
    position: { x: 0, y: 2, z: 15 },
    rotation: { x: 0, y: 1.2, z: 0 },
    skills: ['sales', 'hockey'],
  },
  {
    id: 'hockey',
    titleKey: 'journey.hockey',
    descriptionKey: 'journey.hockey.desc',
    icon: '🏒',
    color: '#ff6b35',
    position: { x: 8, y: 1, z: 20 },
    rotation: { x: 0, y: 1.8, z: 0 },
    skills: ['hockey', 'skating'],
  },
  {
    id: 'skating',
    titleKey: 'journey.skating',
    descriptionKey: 'journey.skating.desc',
    icon: '⛸️',
    color: '#a855f7',
    position: { x: 12, y: 3, z: 25 },
    rotation: { x: 0, y: 2.2, z: 0 },
    skills: ['skating', 'react'],
  },
  {
    id: 'code',
    titleKey: 'journey.code',
    descriptionKey: 'journey.code.desc',
    icon: '💻',
    color: '#00d4ff',
    position: { x: 5, y: 5, z: 30 },
    rotation: { x: 0, y: 2.8, z: 0 },
    skills: ['react', 'python', 'web', 'php', 'git'],
  },
  {
    id: 'ai',
    titleKey: 'journey.ai',
    descriptionKey: 'journey.ai.desc',
    icon: '🤖',
    color: '#ff6b35',
    position: { x: 0, y: 8, z: 35 },
    rotation: { x: 0, y: 3.14, z: 0 },
    skills: ['ai', 'mcp'],
  },
];